var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BaseCardList',{attrs:{"title":_vm.title,"feature-list":_vm.featureList}})
}
var staticRenderFns = []

export { render, staticRenderFns }